if (!customElements.get('endless-collection')) {
  class EndlessCollection extends HTMLElement {
    selectors = {
      loadMoreButton: '[data-load-more]',
      loadMoreContainer: '[data-load-more-container]',
      collectionItems: '[data-collection-items]'
    };
    parser = new DOMParser();
    
    constructor() {
      super();
      this.addEventListener('click', this.handleClick.bind(this));
    }

    /**
     * Click event handler.
     * 
     * @param {Event} event 
     * @returns {void}
     */
    async handleClick(event) {
      if (!event.target.hasAttribute('data-load-more')) return;
      event.preventDefault();

      const nextUrl = this.querySelector(this.selectors.loadMoreButton).getAttribute('href');
      const { productCards, button } = await this.getNextPageMarkup(nextUrl);
      const currentButton = this.querySelector(this.selectors.loadMoreButton);
      
      for (const product of productCards) {
        this.querySelector(this.selectors.collectionItems).appendChild(product);
      }

      if (button.getAttribute('href')) {
        currentButton.replaceWith(button);
      } else {
        this.querySelector(this.selectors.loadMoreContainer).remove();
      }
    }

    /**
     * Gets product cards from an URL.
     * 
     * @param {String} url 
     * @returns {Object} - { productCards: NodeList, button: Node }
     */
    async getNextPageMarkup(url) {
      const response = await fetch(url);
      const data = await response.text();
      const html = this.parser.parseFromString(data, 'text/html');
      return {
        productCards: html.documentElement.querySelectorAll(this.selector),
        button: html.documentElement.querySelector(this.selectors.loadMoreButton),
      };
    }

    connectedCallback() {
      this.selector = 'product-card';

      if(window.location.href.includes('blog')) {
        this.selector = '.article-card';
      }
    }
  }
  customElements.define('endless-collection', EndlessCollection);
}